import { getClientSideHomePageRedirect } from 'Utilities/helpers/getClientSideHomePageRedirect/getClientSideHomePageRedirect';
import { getServerSideHomePageRedirect } from 'Utilities/helpers/getServerSideHomePageRedirect/getServerSideHomePageRedirect';
import isClientSideAuth from 'Utilities/helpers/isClientSideAuth';
import { isServerSideAuth } from 'Utilities/helpers/isServerSideAuth/isServerSideAuth';

import type { GetInitialPropsMiddleware } from '../getInitialPropsMiddlewares.types';

export const unauthorisedOnly: GetInitialPropsMiddleware = async (context, next) => {
	const { nextContext } = context;

	if (nextContext.isSSR) {
		if (isServerSideAuth(nextContext)) {
			getServerSideHomePageRedirect(nextContext);
			return;
		}
	} else if (isClientSideAuth()) {
		await getClientSideHomePageRedirect();
		return;
	}

	await next();
};
